module.exports = __webpack_public_path__ + "static/media/photo195.01a718fc.jpg";